var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetStampPhotoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.501 65.0224L82.4297 59.3293L76.7367 124.401L141.808 130.094L147.501 65.0224Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 31.26C2.50369 29.284 3.0223 27.343 4.00472 25.6285C4.98714 23.914 6.39943 22.4851 8.10237 21.4827C9.8053 20.4803 11.7401 19.9391 13.7159 19.9123C15.6918 19.8855 17.6405 20.3742 19.37 21.33V91.53C17.6405 90.5742 15.6918 90.0855 13.7159 90.1123C11.7401 90.1391 9.8053 90.6803 8.10237 91.6827C6.39943 92.6851 4.98714 94.114 4.00472 95.8285C3.0223 97.543 2.50369 99.484 2.5 101.46V31.26Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2399 77.9001C52.3399 78.8201 53.2399 79.4201 54.4299 79.4201C55.6199 79.4201 56.4299 78.8201 56.4299 77.9801C56.4299 77.1401 55.9299 76.8201 54.7899 76.5301L53.6999 76.2401C52.1299 75.8401 51.4399 75.1501 51.4399 74.0001C51.4399 72.5801 52.6699 71.5901 54.4399 71.5901C54.7978 71.5443 55.1613 71.5715 55.5084 71.6701C55.8555 71.7687 56.179 71.9366 56.4594 72.1637C56.7398 72.3908 56.9713 72.6724 57.1398 72.9915C57.3083 73.3106 57.4104 73.6605 57.4399 74.0201H56.3199C56.2892 73.7961 56.2146 73.5804 56.1005 73.3853C55.9863 73.1902 55.8348 73.0195 55.6547 72.8829C55.4745 72.7464 55.2691 72.6467 55.0504 72.5896C54.8317 72.5325 54.6038 72.5191 54.3799 72.5501C53.2799 72.5501 52.5199 73.1201 52.5199 73.9501C52.5199 74.5901 52.9899 74.9501 54.1399 75.2801L55.0299 75.5101C56.7899 75.9501 57.5099 76.6301 57.5099 77.8501C57.5099 79.4101 56.2799 80.3801 54.3299 80.3801C52.3799 80.3801 51.2699 79.3801 51.1699 77.9001H52.2399Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6498 85.9201C60.2279 85.9201 64.7498 81.3982 64.7498 75.8201C64.7498 70.242 60.2279 65.7201 54.6498 65.7201C49.0717 65.7201 44.5498 70.242 44.5498 75.8201C44.5498 81.3982 49.0717 85.9201 54.6498 85.9201Z",
    stroke: "#B4C5D0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9299 96.19H34.1299V47.49H48.4799",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1401 47.49H99.5601V55.12",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.29 53.6501L80.58 46.0601",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2402 69.61H75.8602",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4999 111H14.0999C12.7103 111 11.3343 110.726 10.051 110.192C8.76778 109.659 7.60253 108.877 6.62221 107.892C5.6419 106.907 4.86584 105.738 4.3386 104.453C3.81136 103.167 3.54334 101.79 3.54992 100.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3198 32.73H114.32V56.88",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.671 70.7991L88.3706 66.2234L83.7949 118.524L136.095 123.099L140.671 70.7991Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.49 96.23L112.87 93.9C111.29 93.76 110.87 94.56 110.69 96.15L108.42 121.76",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2798 120.32L94.6398 93.3801C95.0413 88.8081 97.242 84.5828 100.758 81.6331C104.274 78.6833 108.818 77.2507 113.39 77.6501L141 80.0701",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.76 94.23L126.64 88.24L124.06 85.34L128.92 81.25",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.36 81.6801L124 85.1701",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetStampPhotoGrey);
export default __webpack_public_path__ + "static/media/sheet_stamp_photo_grey.934c5569df3b0a0de7a53b520621532f.svg";
export { ForwardRef as ReactComponent };